export const API_BASE_URL = "https://api.smartshakevending.com";
//export const API_BASE_URL = "http://localhost:5001";
